/* ==========================================================================
   Botaverra - le bouton "Comment ca marche" du hero mene a la section qui
   repond a la question.

   Demande du 2026-08-20. Constat : ce bouton n'avait AUCUN lien. Horizon rend
   alors `<a role="link" aria-disabled="true">` sans href - on clique, rien ne
   se passe, et un lecteur d'ecran l'annonce comme desactive. C'etait le cas
   depuis la mise en ligne, sur le premier ecran du site.

   POURQUOI EN JAVASCRIPT ET PAS DANS LE GABARIT : le lien de ce bouton est un
   reglage de bloc, enregistre dans templates/index.json - 44 Ko, au-dela de ce
   qui peut etre reecrit d'un bloc par l'API sans risque. Le bon endroit reste
   l'editeur de theme ; ce fichier est une bequille, pas une solution.

   IL S'EFFACE TOUT SEUL : le script ne pose un href que si le bouton n'en a
   AUCUN. Le jour ou le champ "Lien" est renseigne dans l'editeur, cette regle
   ne s'applique plus et c'est le reglage qui gagne. Aucun conflit possible,
   rien a desinstaller.

   LA CIBLE EST TROUVEE PAR SA CLASSE, pas par un identifiant ecrit en dur :
   `.bvh` est la section "Botaverra - Hydroponie". Son identifiant de section
   contient le numero du gabarit et changerait si la section etait recreee - un
   lien code en dur deviendrait alors muet, sans message d'erreur.

   LE DEFILEMENT EST FAIT A LA MAIN, avec scrollIntoView, parce que la page ne
   defile pas dans la fenetre mais dans `.page-wrapper` : un simple saut
   d'ancre est moins fiable dans ce cas, et n'aurait pas l'adoucissement.

   PRUDENCE SUR LE CIBLAGE : on ne touche qu'aux liens sans href, situes dans
   #MainContent, et dont le texte contient "comment". Sans cette derniere
   condition, tout lien vide de la page se retrouverait detourne.
   ========================================================================== */

(function () {
  function poser() {
    var section = document.querySelector('.bvh');
    if (!section) return;

    var enveloppe = section.closest('.shopify-section');
    var liens = document.querySelectorAll('#MainContent a:not([href])');

    for (var i = 0; i < liens.length; i++) {
      var a = liens[i];
      if (!/comment/i.test(a.textContent)) continue;

      if (enveloppe && enveloppe.id) a.setAttribute('href', '#' + enveloppe.id);
      a.removeAttribute('aria-disabled');

      a.addEventListener('click', function (e) {
        e.preventDefault();
        var doux = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        section.scrollIntoView({ behavior: doux ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poser);
  } else {
    poser();
  }
})();
